import { TranslateResult } from 'vue-i18n';
import { ComputedRef } from 'vue';
import { Motorisation } from '@dh-io-otb/shared/src/graphql/schema';
import {
  TRACKING_EVENT_ACTION,
  TRACKING_EVENT_LABEL,
  TRACKING_EVENT_NAME,
} from '@dh-io-otb/shared/src/models/constants';

interface FiltersComposable {
  convertArrayToInteractiveTagOption: (
    options?: Array<string>,
    prefix?: string | undefined,
    suffix?: string | undefined,
  ) => FilterOption[];
  setSingleOptionFiltersAsSelected: () => void;
  findArrayName: (str: any, obj: any) => any;
  trackFilterEvents: (action: TRACKING_EVENT_ACTION, label?: TRACKING_EVENT_LABEL) => void;
  trackClearFilterEvents: (action: TRACKING_EVENT_ACTION, name: TRACKING_EVENT_NAME) => void;
  resetFilterByProperty: (filterName: FilterType) => void;
  filterAvailableFuelTypeOptions: () => void;
  filterAvailableTransmissionOptions: () => void;
  filterAvailableDriveTypeOptions: () => void;
  filterAvailableWheelBaseOptions: () => void;
  filterAvailableWeightOptions: () => void;
  filterAvailableMotorisationOptions: () => void;
  getAvailableMotorisations: (filterTypeToExclude: FilterType) => any[];
  checkAvailableOptions: () => void;
  initializeFilters: () => void;
  timePeriodFilters: ComputedRef;
  fuelTypeFilters: ComputedRef;
  motorisationFilters: ComputedRef;
  transmissionFilters: ComputedRef;
  driveTypeFilters: ComputedRef;
  wheelBaseFilters: ComputedRef;
  filteredMotorisations: ComputedRef;
  weightFilters: ComputedRef;
  allVehicleFilters: any;
  updateSelectedFilters: any;
  resetFilters: any;
  resetAllFiltersAndAvailableMotorisations: any;
  numberOfFilteredBookingResults: any;
  motorisationChange: any;
  dealerChange: any;
  selectOption: any;
  filteredBookingResults: any;
  dealersFilters: any;
  enableClearVehiclePreferencesBtn: any;
  enableClearTimePeriodPreferencesBtn: any;
  enableClearDealersPreferencesBtn: any;
  handleDriveTypeSelection: any;
  handleWheelBaseSelection: any;
  handleWeightSelection: any;
  resetFiltersIfNotConfirmed: any;
  resetAllVehicleFiltersInRequest: any;
}

interface FiltersApplied {
  fuelType: TranslateResult;
  transmission: TranslateResult;
  motorisation: Motorisation;
  timePeriod: TranslateResult;
  dealers?: string;
  driveType?: TranslateResult;
  wheelBase?: TranslateResult;
  weight?: TranslateResult;
}

interface AllVehicleFilters {
  fuelTypeFilters: FilterOption[];
  transmissionFilters: FilterOption[];
  motorisationFilters: FilterOption[];
  dealersFilters: FilterOption[];
  timePeriodFilters: FilterOption[];
  driveTypeFilters: FilterOption[];
  wheelBaseFilters: FilterOption[];
  weightFilters: FilterOption[];
}

interface FiltersMenuDealersListClasses {
  'otb-filters-menu__dealer--large': boolean;
}

interface FilterOption {
  text: TranslateResult | string;
  value: string;
  disabled: boolean;
}
interface FilterDealerOption extends FilterOption {
  address: string;
  distanceValue: string;
  distanceUnit: string;
}

enum VehicleFilters {
  FUELTYPE_FILTERS = 'fuelTypeFilters',
  TRANSMISSION_FILTERS = 'transmissionFilters',
  TIME_PERIOD_FILTERS = 'timePeriodFilters',
  DRIVE_TYPE_FILTERS = 'driveTypeFilters',
  WHEELBASE_FILTERS = 'wheelBaseFilters',
  WEIGHT_FILTERS = 'weightFilters',
}

enum VansFilters {
  DRIVE_TYPE_FILTERS = 'driveTypeFilters',
  WHEELBASE_FILTERS = 'wheelBaseFilters',
  WEIGHT_FILTERS = 'weightFilters',
}

enum FilterType {
  FUELTYPE = 'fuelType',
  TRANSMISSION = 'transmission',
  TRANSMISSIONS = 'transmissions',
  MOTORISATION = 'motorisation',
  TIME_PERIOD = 'timePeriod',
  DEALER = 'dealer',
  DEALERS = 'dealers',
  DRIVE_TYPE = 'driveType',
  WHEELBASE = 'wheelBase',
  WEIGHT = 'weight',
}

enum MotorisationProperty {
  FUEL_TYPE = 'fuelType',
  DRIVE_TYPE = 'driveType',
  WEIGHT_CATEGORY = 'weightCategory',
}

enum MotorisationLifecyle {
  ARCHIVED = 'ARCHIVED',
  FOR_SALE = 'FOR_SALE',
  RUNOUT = 'RUNOUT',
}

enum FiltersDefaultValue {
  ALLFUELTYPE = 'ALLFUELTYPE',
  ALLTRANSMISSION = 'ALLTRANSMISSION',
  ALLMOTORISATION = 'ALLMOTORISATION',
  ALLDRIVETYPE = 'ALLDRIVETYPE',
  ALLWHEELBASE = 'ALLWHEELBASE',
  ALLWEIGHT = 'ALLWEIGHT',
  ALLDAY = 'allDay',
}

enum FilterGroupType {
  VEHICLE = 'vehicle',
  TIME_PERIOD = 'timePeriod',
  DEALERS = 'dealers',
}

enum FuelTypeOptions {
  DIESEL = 'DIESEL',
  PETROL = 'PETROL',
  HYBRID = 'HYBRID',
}

enum TransmissionOptions {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
}

enum TimeOfDayOptions {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}

export {
  FiltersComposable,
  FiltersMenuDealersListClasses,
  FilterOption,
  FilterDealerOption,
  FiltersApplied,
  FilterType,
  FilterGroupType,
  FiltersDefaultValue,
  FuelTypeOptions,
  TransmissionOptions,
  TimeOfDayOptions,
  AllVehicleFilters,
  VehicleFilters,
  VansFilters,
  MotorisationProperty,
  MotorisationLifecyle,
};
